import React from 'react'
import PropTypes from 'prop-types'
import { Skeleton, Body1, Link } from '@sainsburys-tech/fable'

import { FULFILMENT_TYPES } from '../fulfilmentBoxUtils'

const FulfilmentContent = ({
  type,
  ctaCopy,
  onCtaClick,
  message,
  location,
  deliveryPostcodeForm,
  additionalContent,
  supplierInfoCTA,
  isValidFulfilment,
  isLoading
}) => {
  if (!isValidFulfilment) {
    return null
  }

  if (isLoading) {
    return <Skeleton width='100%' height='75px' />
  }

  const isDelivery = type === FULFILMENT_TYPES.DELIVERY

  if (isDelivery && deliveryPostcodeForm) return deliveryPostcodeForm

  return (
    <div className='ds-space-y-2'>
      {supplierInfoCTA}
      <Body1 className='ds-font-bold'>{message}</Body1>
      <div className='ds-flex ds-items-start ds-gap-2'>
        <Body1 className='ds-font-bold'>{location}</Body1>
        <Link as='button' onClick={onCtaClick} className='ds-ml-auto ds-justify-end ds-flex-shrink-0'>
          {ctaCopy}
        </Link>
      </div>
      {additionalContent}
    </div>
  )
}

FulfilmentContent.propTypes = {
  type: PropTypes.oneOf([FULFILMENT_TYPES.DELIVERY, FULFILMENT_TYPES.COLLECTION]).isRequired,
  ctaCopy: PropTypes.string.isRequired,
  onCtaClick: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  deliveryPostcodeForm: PropTypes.node,
  additionalContent: PropTypes.node,
  supplierInfoCTA: PropTypes.node,
  isValidFulfilment: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired
}

export default FulfilmentContent
